(ns app.front.view.phase-result
  (:require [app.domain.group.model :as group-model]
            [app.domain.phase-result.model :as phase-result-model]
            [app.front.entity-edit :as ee]
            [app.front.process :as process]
            [app.front.ui.actions :as ui-actions]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(def save-debounce (ee/save-debounce-fn :process.signal/set-phase-result-value))
(def save (ee/save-fn :process.signal/set-phase-result-value))

(defn save-handler [save-fn pc-eid result-eid result-field-key]
  (fn [value]
    (->> value
         (save-fn pc-eid result-eid result-field-key))))

(defn permitted? [fsm-target signal-id]
  (<sub [::process/signal-permitted? fsm-target [signal-id]]))

(defn section-wrapper [state content]
  [section/section
   :phase-result
   state
   :phase-result/result
   true
   content])

(rf/reg-sub ::saving-closure-category
  (fn [db _]
    (::saving-closure-category db false)))

(rf/reg-event-db ::set-category.success
  (fn [db _]
    (assoc db ::saving-closure-category false)))

(rf/reg-event-fx ::set-category
  (fn [{:keys [db]} [_ phase-id result-id category]]
    {:dispatch-n [[::process/signal
                   phase-id
                   [:process.signal/set-closure-category-value
                    {:id               result-id
                     :closure-category (:db/id category)}]
                   {:on-success [::set-category.success]}]]
     :db         (assoc db ::saving-closure-category true)}))

(defn result-section [{:keys [parent fsm-target tr] :as state}]
  (let [{phase-eid :db/id :as phase} (or parent fsm-target)
        result                       (phase-result-model/get-result phase)
        result-eid                   (:db/id result)
        current-desc-value           (<sub [::ee/attr-value result-eid :phase-result/description])
        current-cat-value            (:phase-result/closure-category result)
        can-edit?                    (permitted? phase :process.signal/set-phase-result-value)
        lang                         (<sub [:language])
        closure-categories           (<sub [::ws-subs/closure-categories])
        has-categories?              (not-empty closure-categories)
        can-close?                   (<sub [::process/signal-permitted? phase-eid [:process.signal/set-closure-category-value]])
        val-str-fn                   #(i18n-model/get-text (:closure-category/names %) lang)
        entity-not-fully-saved?      (<sub [::ee/has-any-unsaved?])
        saving-category?             (<sub [::saving-closure-category])
        currently-saving?            (or entity-not-fully-saved? saving-category?)]
    (when (or current-desc-value can-edit?)
      [section-wrapper
       state
       [:<>
        (when has-categories?
          (if can-close?
            [:div.mb-4
             [ui-select/select
              {:id          "category"
               :values      closure-categories
               :value       current-cat-value
               :val->str    val-str-fn
               :select-text (tr [:select-option])
               :label-text  (tr [:closure-category-editor/closure-category])
               :on-change   #(rf/dispatch [::set-category phase-eid result-eid %])}]]
            [:h4.mb-4 (val-str-fn current-cat-value)]))
        [ui-rt/editor-legacy
         (merge
           {:initial-value current-desc-value
            :id            "phase-result-description"}
           (when can-edit?
             {:on-change          (save-handler save-debounce phase-eid result-eid :phase-result/description)
              :on-blur            (save-handler save phase-eid result-eid :phase-result/description)
              :authority-group-id (-> phase group-model/get-authority-group :db/id)
              :aria-label         (tr [:phase-result/result])}))]
        [:div.flex
         [ui-actions/signal-button
          {:target-entity phase-eid
           :signal        [:process.signal/set-closed-without-inspection {}]
           :tr            tr
           :button-opts   {:disabled currently-saving?}}]
         (when currently-saving?
           [:div.ml-4.self-center
            (cc/loading-spinner {:with-overlay false :small true})])]]])))
